var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"site-selector"}},[_c('v-select',{attrs:{"items":_vm.getSites,"item-text":"name","item-value":"id","dense":"","outlined":"","value":_vm.getSites.find(function (site) { return site.id === this$1.getSite.id; })},on:{"input":_vm.changeSite}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }